import { render, staticRenderFns } from "./PicklCompetitions.vue?vue&type=template&id=56d870a2&scoped=true&"
import script from "./PicklCompetitions.vue?vue&type=script&lang=js&"
export * from "./PicklCompetitions.vue?vue&type=script&lang=js&"
import style0 from "./PicklCompetitions.vue?vue&type=style&index=0&id=56d870a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d870a2",
  null
  
)

export default component.exports